export default __webpack_public_path__ + "55f474f9472dae770fae980fc52ae66a.svg";